import { Controller } from "@hotwired/stimulus"
import { makeMatcher } from "../utils/text_match"

// Filtre client de la liste des comptes d'une junior (page « Prendre le
// contrôle »). Chaque ligne porte data-search (nom, email, rôle).
export default class extends Controller {
  static targets = ["search", "row", "count", "empty"]

  filter() {
    const matcher = makeMatcher(this.searchTarget.value)
    let visible = 0

    this.rowTargets.forEach((row) => {
      const show = matcher(row.dataset.search || "")
      row.style.display = show ? "" : "none"
      if (show) visible += 1
    })

    if (this.hasCountTarget) this.countTarget.textContent = visible
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible !== 0 || this.rowTargets.length === 0
  }
}
